<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-8" v-if="disableSaveButtons">
          <button
              type="button"
              class="btn btn-success button-save"
              @click="sendToProduction">
            {{ trans('overproduction.save') }}
          </button>
        </div>
        <div class="col-md-4 text-right" v-if="disableSaveButtons">
          <history route-name="api_get_entity_logger_show_overproduction" :date="this.formDate"></history>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import History from '../../forms/history.vue'

export default {
  name: 'ActionButtons',
  components: {
    History
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    disableSaveButtons: {
      type: Boolean,
      required: true,
    },
    sellBrands: {
      type: Array,
      required: true,
    },
    productionBrands: {
      type: Array,
      required: true,
    },
    deliveryType: {
      type: String,
      required: true
    },
    formDate: {
      type: String,
      required: true
    }
  },
  methods: {
    sendToProduction() {
      const overproductionParams = {
        dateType: this.deliveryType,
        sellBrands: this.sellBrands,
        productionBrands: this.productionBrands,
        date: this.formDate
      }

      this.$emit('sendToProduction', overproductionParams)
    },
    save() {
      const overproductionParams = {
        dateType: this.deliveryType,
        sellBrands: this.sellBrands,
        productionBrands: this.productionBrands,
        date: this.formDate
      }

      this.$emit('save', overproductionParams)
    }
  }
}
</script>